import OneSignal from 'onesignal-cordova-plugin';

import { inject, Injectable } from '@angular/core';
import { AlertController, NavController, Platform } from '@ionic/angular';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  #navCtrl: NavController = inject(NavController);
  /**
   * Constructor of the Service with Dependency Injection
   * @param http The standard Angular HttpClient to make requests
   */
  constructor(private auth: AuthService, private platform: Platform, private alertCtrl: AlertController) {}

  async handlerNotifications(): Promise<void> {
    const platformReady = await this.platform.ready();
    if (platformReady && this.platform.is('capacitor')) {
      // Uncomment to set OneSignal device logging to VERBOSE
      // OneSignal.Debug.setLogLevel(6);

      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      OneSignal.initialize('b03ca7d4-f532-4d63-997a-1c3f78ca8156');
      OneSignal.Notifications.addEventListener('click', async (e) => {
        const clickData = await e.notification;
        console.log('Notification Clicked : ' + JSON.stringify(clickData));
        this.auth.getUser().then((user) => {
          if (user) {
            self.#navCtrl.navigateRoot(['/tecservice-transportec/wallet/notifications']);
          }
        });
      });

      const permission = await OneSignal.Notifications.requestPermission(true);

      if (permission) {
        this.auth.getUser().then((user) => {
          OneSignal.User.addTags({
            id: user.id,
            type: user.type,
          });
        });
      }
    }
  }

  async showAlert(title: string = 'Notificación', msg: string = '', task: string = 'OK') {
    const alert = await this.alertCtrl.create({
      header: title,
      subHeader: msg,
      buttons: [
        {
          text: `${task}`,
          handler: () => {
            // E.g: Navigate to a specific screen
          },
        },
      ],
    });
    alert.present();
  }
}
